import { formatDatetime, type FormatDatetimeOptions } from '@aigc/toolkit';

export interface DatetimeProps extends FormatDatetimeOptions {
  /**
   * 需要格式化的时间
   */
  value?: Date | string | number | null;

  /**
   * 时间格式
   *
   * 默认为 yyyy-MM-dd HH:mm:ss
   */
  format?: string;

  /**
   * 自定义样式
   */
  className?: string;

  /**
   * 标题
   */
  title?: string;
}

/**
 * 时间展示组件
 *
 * 默认时间格式为 yyyy-MM-dd HH:mm:ss
 */
export const Datetime = (props: DatetimeProps) => {
  if (props.value == null) {
    return null;
  }

  const datetime = formatDatetime(props.value, props.format, {
    sourceFormat: props.sourceFormat,
  });

  if (!datetime) {
    return null;
  }

  return (
    <span className={props.className} title={props.title ?? datetime ?? void 0}>
      {datetime}
    </span>
  );
};
